import { inject } from 'vue'

export const playerServiceKey = Symbol('playerService')

export function usePlayerService() {
    const playerService = inject(playerServiceKey, null)

    if (!playerService) throw new Error('Player service is not registered.')

    return playerService
}
